import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Instagram, Mail, Send } from "lucide-react";
import { Reveal, Eyebrow } from "../components/motion";
import { API_URL, SITE } from "../config/site";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await axios.post(`${API_URL}/contact`, form);
      toast.success(data.message);
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Qualcosa è andato storto. Riprova.");
    } finally {
      setSending(false);
    }
  };

  return (
    <main data-testid="contact-page" className="py-14 sm:py-20">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center">
          <Reveal>
            <Eyebrow className="justify-center">Contatti</Eyebrow>
            <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-plum tracking-tight">
              Parliamone insieme
            </h1>
            <p className="mt-4 text-base sm:text-lg text-plum/60 max-w-xl mx-auto">
              Hai un dubbio su quale percorso scegliere o su come usare un prodotto? Scrivici: ti aiutiamo volentieri.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          <Reveal>
            <div className="bg-lilac-soft border border-lilac-light rounded-[2rem] p-8 h-full">
              <h2 className="font-serif text-xl text-plum">Dove trovarci</h2>
              <div className="mt-6 space-y-4">
                <a
                  data-testid="contact-instagram"
                  href={SITE.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 bg-white rounded-2xl p-4 hover:-translate-y-0.5 hover:shadow-md transition-all duration-300"
                >
                  <span className="w-10 h-10 rounded-full bg-lilac flex items-center justify-center">
                    <Instagram className="w-4 h-4 text-white" />
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-plum">@fatima_bio_cosmetic_it</p>
                    <p className="text-xs text-plum/50">Scrivici in DM, rispondiamo ogni giorno</p>
                  </div>
                </a>
                <a
                  data-testid="contact-email"
                  href={`mailto:${SITE.email}`}
                  className="flex items-center gap-3 bg-white rounded-2xl p-4 hover:-translate-y-0.5 hover:shadow-md transition-all duration-300"
                >
                  <span className="w-10 h-10 rounded-full bg-lilac flex items-center justify-center">
                    <Mail className="w-4 h-4 text-white" />
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-plum">{SITE.email}</p>
                    <p className="text-xs text-plum/50">Per ordini, collaborazioni e domande</p>
                  </div>
                </a>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <form onSubmit={submit} className="bg-mist rounded-[2rem] p-8 space-y-4" data-testid="contact-form">
              <input
                data-testid="contact-name-input"
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Il tuo nome"
                className="w-full bg-white rounded-2xl px-5 py-4 text-sm text-plum outline-none border border-transparent focus:border-lilac-dark transition-colors"
              />
              <input
                data-testid="contact-email-input"
                required
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="La tua email"
                className="w-full bg-white rounded-2xl px-5 py-4 text-sm text-plum outline-none border border-transparent focus:border-lilac-dark transition-colors"
              />
              <textarea
                data-testid="contact-message-input"
                required
                minLength={5}
                rows={4}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                placeholder="Come possiamo aiutarti?"
                className="w-full bg-white rounded-2xl px-5 py-4 text-sm text-plum outline-none border border-transparent focus:border-lilac-dark transition-colors resize-none"
              />
              <button
                data-testid="contact-submit-btn"
                disabled={sending}
                className="w-full flex items-center justify-center gap-2 py-4 rounded-full bg-lilac text-white font-bold text-sm uppercase tracking-[0.14em] hover:bg-lilac-dark active:scale-[0.98] transition-all duration-300 disabled:opacity-60"
              >
                <Send className="w-4 h-4" /> {sending ? "Invio..." : "Invia messaggio"}
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </main>
  );
}
